import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Assignment } from './assignment';
import { AnswerService } from './answers.service';

interface AssignmentResponse {
  user: any;
  assignments: Assignment[];
}

@Injectable({
  providedIn: 'root',
})
export class AssignmentService {
  constructor(private http: HttpClient,
    private answerService: AnswerService,
  ) {}

  async getAssignmentsForUser(): Promise<AssignmentResponse> {
    return await this.http.get<AssignmentResponse>(`user/assignments`).toPromise();
  }
  
  async assignTasks(payload: {
    courseId: string;
    studentIds: string[];
    exerciseId: string;
    questionCount?: number;
    deadline?: string;
  }): Promise<any> {
    return await this.http.post('assignments', payload).toPromise();
  }

  async updateAssignment(payload: {
    ids: string[];
    deadline: string;
  }): Promise<any> {
    return await this.http.post('assignments/update', payload).toPromise();
  }

  async deleteAssignments(ids: string[]): Promise<any> {
    return await this.http.request('delete', 'assignments/delete', {
      body: { ids },
    }).toPromise();
  }

  async getCompletionStatus(assignmentId: string): Promise<any> {
    return await this.http.get(`assignments/status?assignment=${assignmentId}`).toPromise();
  }

  async deleteForStudents(exerciseId: string, studentIds: string[]): Promise<any> {
    return await this.http.request('delete', 'assignments/delete-for-students', {
      body: { exerciseId, studentIds },
    }).toPromise();
  }

  public async getUpcomingAssignmentsForUser(userId: string): Promise<Assignment[]> {
    const response = await this.getAssignmentsForUser();
  
    const allAssignments = response?.assignments || [];
  
    if (allAssignments.length === 0) {
      return [];
    }
  
    const results = await Promise.all(
      allAssignments.map(async assignment => {
        const answers = await this.answerService.getAnswersForAssignment(assignment._id);
        return {
          assignment,
          answeredCount: answers.length
        };
      })
    );
  
    return results
      .filter(r => r.answeredCount < r.assignment.questionCount)
      .map(r => r.assignment);
  }  
}
